import * as React from "react";

import { useDispatch } from "react-redux";

import { useLocation } from "react-router-dom";

import { Stack } from "@mui/material";

import PropTypes from "prop-types";

import { USER_INFO } from "Shared/Constants/appConstants";

import { fetchUserConfig, fetchMenus } from "App/appActions";

import Header from "./Header";

function Layout({ children }) {
  const dispatch = useDispatch();
  const location = useLocation();

  React.useEffect(() => {
    const leadIdMatch = location.pathname.match(/\/vehicle-summary\/([^/]+)/);
    const leadId = leadIdMatch?.length > 0 ? leadIdMatch[1] : null;
    const queryParam = leadId ? `?leadId=${leadId}` : "";
    dispatch(fetchUserConfig(queryParam));
    dispatch(fetchMenus());

    // Get user info from userProfile (set by auth-context)
    const userProfile = localStorage.getItem("userProfile");
    if (userProfile) {
      localStorage.setItem(USER_INFO, userProfile);
    }
  }, [dispatch, location.pathname]);

  return (
    <Stack>
      <Header />
      <Stack
        direction="row"
        alignItems="center"
        // bgcolor="#F0F3F5"
        mt="10rem"
      >
        {children}
      </Stack>
    </Stack>
  );
}

export default Layout;

Layout.propTypes = {
  children: PropTypes.element.isRequired
};
